// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
const GET_DATE_FOOD_MEALS_REQUESTS_SUCCESS =
  "GET_DATE_FOOD_MEALS_REQUESTS_SUCCESS";
const GET_DATE_FOOD_MEAL_REQUESTS_SUCCESS =
  "GET_DATE_FOOD_MEAL_REQUESTS_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _getRequestDateFoodMealsSuccess(payload) {
  return {
    type: GET_DATE_FOOD_MEALS_REQUESTS_SUCCESS,
    payload: payload.data,
  };
}
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _getRequestDateFoodMealSuccess(payload) {
  return {
    type: GET_DATE_FOOD_MEAL_REQUESTS_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 * @param {object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequestDateFoodMeals(params = {}, callback = (r) => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/feeding/GetMealsByDate/${params}`)
      .then((r) => {
        dispatch(_getRequestDateFoodMealsSuccess(r));
        callback(r);
      })
      .catch((e) => {});
  };
}
/**
 * @param {number} dateFoodMealsId
 * @param {object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequestDateFoodMeal(
  dateFoodMealsId,
  params = {},
  callback = (r) => {}
) {
  return (dispatch, gs, api) => {
    api
      .get(`/feeding/date_food_meal_assign/${dateFoodMealsId}`, { params })
      .then((r) => {
        dispatch(_getRequestDateFoodMealSuccess(r));
        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequestDateFoodMeals() {
  return _getRequestDateFoodMealsSuccess({
    data: { daily_dateFoodMeals: [] },
    meta: {},
  });
}
/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequestDateFoodMeal() {
  return _getRequestDateFoodMealSuccess({
    data: { daily_dateFoodMeal: {} },
    meta: {},
  });
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    dateFoodMeals: [],
    dateFoodMeal: {},
  },
  action
) {
  switch (action.type) {
    case GET_DATE_FOOD_MEALS_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        dateFoodMeals: action.payload.dateFoodMeals,
      });
    case GET_DATE_FOOD_MEAL_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        dateFoodMeal: action.payload.dateFoodMeal,
      });
    default:
      return state;
  }
}
